module.exports = __webpack_public_path__ + "media/media/social/linkedin-logo-a90baf6a996dbff6e5b3381fe2ff6249.png";